const LEVEL = "preprod";

const commons = {

};

const dev = {
    debug : true,
    logEnabled : true,
    logLevel : 'debug', // debug, info, warning, error
    server : 'http://localhost:15015',
};
const preprod = {
    debug : true,
    logEnabled : true,
    logLevel : 'debug', // debug, info, warning, error
    server : 'https://api.ngs.artcentrica.com',
};
const prod = {
    debug : false,
    logEnabled : true,
    logLevel : 'warning', // debug, info, warning, error
    server : 'https://api.ngs.artcentrica.com',
};

let config;

switch (LEVEL) {
    case "prod":
        config = Object.assign(commons, prod);
        break;
    case "preprod":
        config = Object.assign(commons, preprod);
        break;
    case "dev":
    default:
        config = Object.assign(commons, dev);
        break;
}

export default config;